<template>
  <svg
    class="iconfont"
    :class="iconClass"
    :style="iconStyle"
    aria-hidden="true"
  >
    <use :xlink:href="symbolId" />
  </svg>
</template>

<script>
export default {
  name: 'IconFont',
  props: {
    /** iconfont symbol id，如 icon-bangzhu_o */
    name: {
      type: String,
      required: true
    },
    size: {
      type: [Number, String],
      default: 16
    },
    iconClass: {
      type: [String, Array, Object],
      default: ''
    }
  },
  computed: {
    symbolId() {
      if (this.name.startsWith('#')) return this.name
      if (this.name.startsWith('icon-')) return `#${this.name}`
      return `#icon-${this.name}`
    },
    iconStyle() {
      const size = Number(this.size)
      return {
        width: `${size}px`,
        height: `${size}px`
      }
    }
  }
}
</script>
